import axios from 'axios';
import Settings from '../../../settings.json';

const url = Settings.isNative ? Settings.frontlineArServer : '';

export class ContentRequester {

    static async getProjects(workspace, {skip = 0, limit = 20, search = ''} = {}) {
        const result = await axios.post(`${url}/ContentManagement/${workspace}/GetProjects`, {skip, limit, search});
        return result.data;
    }

    static async getChildrenFoldersAndProcedures(workspace, {parentId, parentType, nestedRoute, skip = 0, limit = 20, search = '', includePublishedRoles = false, includeLevel} = {}) {
        const result = await axios.post(`${url}/ContentManagement/${workspace}/GetChildrenFoldersAndProcedures`, {parentId, parentType, nestedRoute, skip, limit, search, includePublishedRoles, includeLevel});
        return result.data;
    }

    static async searchContent(workspace, searchTerm) {
        const result = await axios.post(`${url}/ContentManagement/${workspace}/SearchContent`, {searchTerm});
        return result.data;
    }
}
